// extracted by mini-css-extract-plugin
export default {"inputsWrapper":"SelectableIconFormField_inputsWrapper__fFRQD"};